import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Events } from 'ionic-angular';
import { EVENTS_CONFIG } from './../../configs/events.config';
import { COOKIES_CONFIG } from './../../configs/cookies.config';

/**
 * APIの認証で利用する情報をStoreとして管理しておく
 * - やりたいことはシングルトンとして管理できていればそれだけでOKという認識
 */
@Injectable()
export class ApiAuthStore {

  private _apiUrl:string;
  private _apiToken:string;
  private _deviceUuid:string;
  private _licenseKey:string;

  constructor(
    private events: Events,
    private storage: Storage
  ){

    // ライセンスキー変更イベントを検知する
    this.events.subscribe(EVENTS_CONFIG.LICENSE_KEY, (licenseKey) => {
      // 接続先のAPI情報をセット
      this.setLicenseKey(licenseKey)
    })

    // URL変更イベントを検知する
    this.events.subscribe(EVENTS_CONFIG.API_URL, (url) => {
      // urlをセットする
      this.setUrl(url)
    })

    // トークン変更イベントを検知する
    this.events.subscribe(EVENTS_CONFIG.TOKEN, (token) => {
      // tokenをセットする
      this.setToken(token)
    })

    // UUID変更イベントを検知する
    this.events.subscribe(EVENTS_CONFIG.UUID, (uuid) => {
      // uuidをセットする
      this.setUuid(uuid)
    })

  }

  get url() {
    return this._apiUrl
  }

  async getUrl(){
    // console.log('*** ApiAuthStoe:getter url::' + this._apiUrl);
    if (!this._apiUrl) {
      this._apiUrl = await this.storage.get(COOKIES_CONFIG.API_URL)
    }
    return this._apiUrl;
  }

  async setUrl(url) {
    // console.log('APIのURLをセットする:' + url);
    await this.storage.set(COOKIES_CONFIG.API_URL, url)
    this._apiUrl = url
  }

  async getToken() {
    if (!this._apiToken) {
      this._apiToken = await this.storage.get(COOKIES_CONFIG.API_TOKEN)
    }
    return this._apiToken
  }

  async setToken(token) {
    // console.log('Tokenをセット:' + token);
    if (token) {
      await this.storage.set(COOKIES_CONFIG.API_TOKEN, token)
      this._apiToken = token
    }
  }

  async removeToken() {
    await this.storage.remove(COOKIES_CONFIG.API_TOKEN)
    this._apiToken = null
  }

  async getUuid() {
    if (!this._deviceUuid) {
      this._deviceUuid = await this.storage.get(COOKIES_CONFIG.DEVISE_UUID)
    }
    return this._deviceUuid
  }

  async setUuid(uuid){
    // console.log('UUIDをセット:' + uuid);
    await this.storage.set(COOKIES_CONFIG.DEVISE_UUID, uuid)
    this._deviceUuid = uuid
  }

  async getLicenseKey() {
    // console.log('*** ApiAuthStore:getter licenseKey: ' + this._licenseKey);
    if (!this._licenseKey) {
      this._licenseKey = await this.storage.get(COOKIES_CONFIG.SYSTEM_TYPE) || ""
    }
    return this._licenseKey
  }

  async setLicenseKey(licenseKey) {
    // console.log('LicenseKeyをセット:' + licenseKey);
    await this.storage.set(COOKIES_CONFIG.SYSTEM_TYPE, licenseKey)
    this._licenseKey = licenseKey
  }

};


// WEBPACK FOOTER //
// ./src/providers/store/api.auth.store.ts